<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color: #101129 !important;">
      <div class="display-content" v-if="toReload" style="position:relative">
        <div
          style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 35px;
                left: 0;
              "
        >
              <span @click="toggleApi" style="margin-right:2rem">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
          <span @click="goback">
                <span class="fullscreen-btn">返回首页</span>
              </span>
        </div>
        <div
          style="
                width: 98%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 85px;
                left: 25px;
              "
        >
          <button class="cool-button" @click="goData">综合数据</button>
          <button class="cool-button" @click="goSchool" >体教融合</button>
          <button class="cool-button" @click="goOrgan">组织架构</button>
          <button class="cool-button-active"  >基础设施</button>
          <button class="cool-button" @click="goKeyCity">重点城市</button>
        </div>
        <div class="leftTop">

          <div style="display:flex">
            <!--左半边-->
            <div class="column left">
              <!--精英机构数量-->
              <div class="row class-all" style="height:160px">
                <div class="com-wrapper">
                  <statistical-com
                    :numStatistical="statisticsToCounty"
                    :title="'精英机构场地数量'"
                  ></statistical-com>
                </div>
              </div>

              <!--球队饼状图-->
              <div class="row class-all"  style="height:295px">
                <div class="pie-wrapper">
                  <template v-if="isShowChild">
                    <pie-com
                      :propsReloadTime="reloadTime"
                      :statisticsSquadLevel = "propsFootballChan"
                      :statisticsQuality= "propsFootballQuality"
                    ></pie-com>
                  </template>
                </div>
              </div>

            </div>
            <!--中间-->
            <div class="column center">
              <!--地图-->
              <div class="map-canvas" style="position: relative">
                <div class="map-title">
                  <!-- {{ year }}年各省/自治区/直辖市/特别行政区开班数量 -->
                  <p style="font-weight: bold;">基础设施大数据</p>
                </div>
                <div class="echart-map-wrapper" >
                  <template v-if="isShowChild">
                    <div style="text-align: center">
                      <img :src="eleven" alt="" width="200" height="300" style="margin-top:35px;border-radius: 10px">
                      <p style="margin-top:35px;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          十一人制:
                        </span>
                        <span style="color: #ffbd57; font-size:16px">
                          {{propsFootballNum['十一人制']}}
                        </span>
                      </p>
                      <p style="margin-top:3rem;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          天然草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoEleven['天然草']}}
                        </span>
                        <span style="color: #68d8fe; margin-left:5px">
                          人工草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoEleven['人工草']}}
                        </span>
                      </p>
                    </div>
                    <div style="text-align: center">
                      <img :src="eight" alt="" width="170" height="280" style="margin-top:45px;border-radius: 10px">

                      <p style="margin-top:45px;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          八人制:
                        </span>
                        <span style="color: #ffbd57; font-size:16px">
                          {{propsFootballNum['八人制']}}
                        </span>
                      </p>
                      <p style="margin-top:3rem;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          天然草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoEight['天然草']}}
                        </span>
                        <span style="color: #68d8fe; margin-left:5px">
                          人工草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoEight['人工草']}}
                        </span>
                      </p>
                    </div>
                    <div style="text-align: center">
                      <img :src="five" alt="" width="170" height="260" style="margin-top:55px;border-radius: 10px">
                      <p style="margin-top:55px;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          五人制:
                        </span>
                        <span style="color: #ffbd57; font-size:16px">
                          {{propsFootballNum['五人制']}}
                        </span>
                      </p>
                      <p style="margin-top:3rem;font-weight:bold;font-size:15px">
                        <span style="color: #68d8fe; ">
                          天然草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoFive['天然草']}}
                        </span>
                        <span style="color: #68d8fe; margin-left:5px">
                          人工草:
                        </span>
                        <span style="color: #ffbd57;font-size:16px ">
                          {{propsFootballCaoFive['人工草']}}
                        </span>
                      </p>

                    </div>

                  </template>
                </div>
              </div>
            </div>
          </div>
            <div style="margin-right:1.5rem">
              <div class="column">
                <div class="row class-all">
                  <div class="line-wrapper">
                    <template v-if="isShowChild">
                      <line-com
                        :playerNum="playerShiyi"
                        :playerNumZhong="playerBa"
                        :playerNumGao="playerWu"
                        :playerKey="playerKey">
                      </line-com>
                    </template>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="column right" style="display:block">
          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/video-solid.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                场地安装高清视频系统：{{facilityAssistsMap.videoSystem}}
              </span>
              <el-progress :percentage="facilityAssistsMap.videoSystem / 16 * 100"></el-progress>
            </div>

          </div>
          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/money-bill-trend-up-solid.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                引入EPTS（电子表现跟踪系统）：{{facilityAssistsMap.expressionSystem}}
              </span>
              <el-progress :percentage="facilityAssistsMap.expressionSystem / 16 * 100"></el-progress>
            </div>

          </div>
          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/shower-solid.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                场地附近有运动员更衣室 / 淋浴间 / 体能训练房等功能房设施：{{facilityAssistsMap.changingRoom}}
              </span>
              <el-progress :percentage="facilityAssistsMap.changingRoom / 16 * 100"></el-progress>
            </div>

          </div>
          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/hospital-regular.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                各场地设立医务室，配备AED设备：{{facilityAssistsMap.dispensary}}
              </span>
              <el-progress :percentage="facilityAssistsMap.dispensary / 16 * 100"></el-progress>
            </div>

          </div>

          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/building-user-solid.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                各场地周边配备行政用房：{{facilityAssistsMap.occupancy}}
              </span>
              <el-progress :percentage="facilityAssistsMap.occupancy / 16 * 100"></el-progress>
            </div>

          </div>
          <div class="row class-all facilitisItem" >
            <div>
              <img src="@/assets/images/statistics/people-roof-solid.svg" alt="" width="50">
            </div>
            <div class="com-wrapper siteItem">
              <span>
                有容纳50人以上的现代化多媒体教室：{{facilityAssistsMap.classroom}}
              </span>
              <el-progress :percentage="facilityAssistsMap.classroom / 16 * 100"></el-progress>
            </div>

          </div>
        </div>
      </div>

    </fullscreen>
  </div>
</template>

<script>
  import VueFullscreen from "vue-fullscreen";
  import Vue from "vue";
  import  statistics  from "@/api/statistics";
  import five from '@/assets/images/common/five.png'
  import eleven from '@/assets/images/common/eleven.png'
  import eight from '@/assets/images/common/eight.png'
  Vue.use(VueFullscreen);

  export default {
    data() {
      return {
        five,
        eleven,
        eight,
        fullscreen: false,
        isFullscreen: false,
        toReload: true,
        mapName: "echartsTestProvince",
        mapProvinceName: "上海",
        isShowChild: true,
        statisticsToCounty:{},// 精英机构分布区县

        playerShiyi: [], // 球员数量
        playerBa: [], // 球员数量
        playerWu: [], // 球员数量

        playerKey: [], // 球员所在机构简称
        reloadTime: 30000,  // ms
        type: 'allYouth',  // ms
        propsFootballNum:{},
        propsFootballChan:[],
        propsFootballQuality:[],
        propsFootballCaoEight:{},
        propsFootballCaoEleven:{},
        propsFootballCaoFive:{},
        facilityAssistsToYouthMap:{},
        facilityAssistsMap:{},

        statisticsSquadLevelVosMan:{},// 球队饼状图
        statisticsSquadLevelVosWomen:{},// 球队饼状图
        stuNumAll:0,
        stuNumAllWomen:0,
        manSchoolComplete:'',
        womanSchoolComplete:'',
        schoolCompleteWomen:{},// 完成女足321体系的机构
        schoolComplete:{},//完成男足631体系的机构
      };
    },

    components:{
      "statistical-com": () => import("./SiteFacilitiesStatistics/footBallNumStatistical"), // 精英机构数量统计
      "pie-com": () => import("./SiteFacilitiesStatistics/footballPropertyStatistics"), // 球队统计
      "teacher-com": () => import("./components/CoachStatistics"), // 教练统计
      "map-com": () => import("./EchartsProvinceFootball"), // 地图
      "line-com": () => import("./SiteFacilitiesStatistics/footBallNumToYouthStatistics"), // 球员统计
      "toturial-com": () => import("./components/PlanStatistical"), // 训练计划数量
      "waterFall-com": () => import("./components/PlanData"), // 训练计划滚动
      "tutorial-line-com": () => import("./components/TeachingStatistics"), // 教案库统计
    },

    computed: {

    },

    mounted() {
      this.isShowChild = false;
      this.loadInfo();
      document.getElementsByTagName('html')[0].style.fontSize = '11px';
    },

    destroyed() {
      document.getElementsByTagName('html')[0].style.fontSize = '10.672358591248667vh';
    },


    methods: {
      toggleApi() {
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
          teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback: (isFullscreen) => {
            that.fullscreen = isFullscreen;
          },
        });
      },
      goSchool(){
        this.$router.push({
          path: '/statisticsSchool',
        })
      },
      goOrgan(){
        this.$router.push({
          path: '/statisticsOrganizational',
        })
      },
      goKeyCity(){
        this.$router.push({
          path: '/statisticsKeyCityTrain',
        })
      },
      goData(){
        this.$router.push({
          path: '/statistics',
        })
      },
      goback(){
        this.$router.push({
          path: '/',
        })
      },
      loadInfo() {
        statistics.getSchoolSiteFacilities()
        .then(res => {
          const {
            footballNum,  // 场地数量
            footballChan,  // 产权类型
            footballQuality,  // 性质
            facilityAssistsToYouthMap,
            facilityAssistsMap,
            footballCaoEleven,  // 草皮类型
            footballCaoEight,  // 草皮类型
            footballCaoFive,  // 草皮类型
            playerNumVos,  // 机构的场地数量
            statisticsToCounty
          } = res;

          // region 球员柱状图
          let playerShiyi = []; // 球员数量
          let playerBa = []; // 球员数量
          let playerWu = []; // 球员数量
          let playerKey = []; // 球员所在机构简称
          if(playerNumVos && playerNumVos.length) {
            playerNumVos.forEach((item,index) => {
              playerShiyi[index] = item.shiyi;
              playerBa[index] = item.ba;
              playerWu[index] = item.wu;
              playerKey[index] = item.playerKey;
            });
          }
          this.playerShiyi = playerShiyi;
          this.playerBa = playerBa;
          this.playerWu = playerWu;
          this.playerKey = playerKey;
          // endregion

          this.propsFootballNum = footballNum;
          this.propsFootballChan = footballChan;
          this.propsFootballQuality = footballQuality;
          this.propsFootballCaoEleven = footballCaoEleven;
          this.propsFootballCaoEight = footballCaoEight;
          this.propsFootballCaoFive = footballCaoFive;
          this.facilityAssistsToYouthMap=facilityAssistsToYouthMap;
          this.facilityAssistsMap=facilityAssistsMap;
          this.statisticsToCounty=statisticsToCounty;

          this.isShowChild = true; // 开始画图
        })
        .catch((err) => {
          console.error("err", err);
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'
  .display-wrapper
    width 100%
    height 100%

    font-size 12px !important
    background-color #101129 !important
  .display-content
    font-size 12px !important
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    margin 0 auto
    display flex
    padding 9rem 0.8rem 0
    background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
    .cool-button
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #60c5e9, #2a4d6a);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .cool-button:hover
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      transform: skew(-15deg) translateY(-2px); /* 保持倾斜并提升按钮位置 */
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    .cool-button-active
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .leftTop
      display: block;
      position: relative;
      -webkit-box-flex: 3;
      -ms-flex: 3;
      flex: 7;
    .column
      position relative
      flex 3
      .facilitisItem
        display flex
      .row
        box-sizing border-box
        border 2px solid red
        border-image url('../../assets/images/display/border.png') 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 4rem
        color #FFFFFF
      .row-content
        position absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem 2rem
      .class-all
        min-height 110px
        .row-title
          color #68d8fe
          font-weight 600
          font-size 16px
          margin-bottom 0.4rem
          display flex
          align-items center
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 0.8rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          .btn-active
            background-color #0bace6
            color #FFFFFF
        .data-wrapper
          display flex
          flex-wrap wrap
          .data-item
            flex 1
            font-size 12px
            text-align center
            .data
              font-size 26px
            .data-title
              color #4c9bfd
              margin-top 5px
        .siteItem
          font-size 16px
          flex 3
          margin-left 1rem
      .class-table
        height 350px
        .row-content
          padding 1.25rem 0
        .nav-title-wrapper
          padding-left 1.25rem
          margin-bottom 0.8rem
          .nav-item
            margin-right 15px
            cursor pointer
            color #1950c4
            padding-right 15px
            border-right 2px solid #00f2f1
            &:last-child
              border-right none
          .active-title
            color #FFFFFF
        .table-wrapper
          .table-head
            display flex
            width 100%
            background-color rgba(255, 255, 255, 0.1)
            color #68d8fe
            padding 0 1rem
            line-height 3rem
            .table-column
              /* flex 1 */
              text-align center
              &:nth-child(1)
                width 20%
              &:nth-child(2)
                width 30%
              &:nth-child(3)
                width 20%
              &:nth-child(4)
                width 15%
              &:nth-child(5)
                width 15%
          .table-content
            height 250px
            overflow hidden
            .table-row
              width 100%
              display flex
              padding 0 1rem
              line-height 2.5rem
              color #61a8ff
              &:hover
                background-color rgba(255, 255, 255, 0.1)
                color #68d8fe
              .table-col
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                text-align center
                &:nth-child(1)
                  width 20%
                &:nth-child(2)
                  width 30%
                &:nth-child(3)
                  width 20%
                &:nth-child(4)
                  width 15%
                &:nth-child(5)
                  width 15%
    .right
      .class-all
        border-width: 4.125rem 1.583rem 0.875rem 2rem;
    .center
      flex 4
      margin 3.8rem 1.5rem 0
      .map-title
        color #68d8fe
        font-size 1.6rem
        text-align center
      .echart-map
        width 100%
        /* height 440px + 4.875rem */
        height 455px
      .online
        position absolute
        top -18px
        left 0
        z-index 999
        .online-content
          width inherit
          height inherit
          position absolute
          top -40px
          left -56px
          display flex
          flex-direction column
          .title
            width 100%
            color #68d8fe
            font-size 1.6rem
            line-height 4rem
            text-align center
          .content
            flex 1
            font-size 2.4rem
            display flex
            justify-content center
            align-items center
  .table-content
    .animation-wrapper
      animation row 20s linear infinite
      &:hover
        animation-play-state paused
  .tutorial-add
    height 350px !important
    .data-wrapper
      height 90%
    .echart-tutorial-add
      width 100%
      height 100%
  .login-data
    height 340px !important
    .data-wrapper
      height 90%
    .echart-user-login
      width 100%
      height 100%
  .class-vip
    height 340px !important
    .data-wrapper
      height 90%
    .echart-class-status
      width 100%
      height 100%
  .user-all
    height 340px !important
    margin-top 4.6rem
    .flex-box
      display flex
      width 100%
      height 100%
      .flex-item
        /* flex 1 1 */
        height 100%
        .data-wrapper
          height 100%
      .left
        flex 5
      .right
        flex 2
        padding 8rem 2rem 8rem 2rem
        display flex
        flex-direction column
        justify-content space-around
        font-size 1.4rem
        color #61a8ff
        text-align center
        .line-text
          /* text-align left */
          display flex
          justify-content space-between
          span:nth-child(1)
            display flex
            align-items center
            justify-content flex-start
          span:nth-child(2)
            font-size 2.5rem
            margin-left 5px
            color #FFFFFF
            text-align left
            display block
            width 6rem
    .echart-associate-all
      width 100%
      height 100%
  @keyframes row
    0%, 100%
      transform translateY(-50%)
  .fullscreen-btn
    color #61a8ff
    cursor pointer
</style>

<style lang="stylus" scoped>
  .h290
    height 290px
  .echart-map-wrapper
    height 462px
    box-sizing border-box
    padding-bottom 13px
    display flex
    justify-content space-around
  .pie-wrapper
    // height 250px
    height 290px
    width 100%
  .line-wrapper
    // height 250px
    height 283px
  .grade-wrapper
    height 290px
  .login-wrapper
    // height 250px
    height 290px
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0b93d5
      color #68d8fe
  /* .el-select-dropdown */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  /* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  .display-wrapper
   .el-progress
     margin-top: 1rem;
     .el-progress__text
       color #68d8fe
   .el-progress-bar
     padding-right: 70px;
     margin-right: -60px;

</style>
